import React, {useEffect, useState} from "react";
import {Box, Button, Flex, Input, Table, Tbody, Td, Th, Thead, Tr} from "@chakra-ui/react";
import {searchMeta} from "./Services";

function Setting() {
    const [metaData, setMetaData] = useState([]);


    useEffect(() => {
        fetchMetaList();
    }, []);

    const fetchMetaList = async () => {
        try {
            const response = await searchMeta();
            if (response.data) {
                setMetaData(response.data);
            }
        } catch (e) {
            console.error(e);
        }
    }

    const handleInputChange = (id, field, value) => {
        const updatedMeta = metaData.map((meta) =>
            meta.id === id ? {...meta, [field]: value} : meta
        );
        setMetaData(updatedMeta);
    };

    const handleSave = () => {
        console.log("Updated Meta Data:", metaData);
        // Add your save logic here (API call or DB update)
    };

    return (
        <Flex direction="column" pt={{base: "100px", md: "75px"}} bg="gray.50" minHeight="100vh"
              px={{base: "4", md: "6"}}>
            {/*<Box mb={4}>*/}
            {/*    <Text fontSize="lg" fontWeight="bold">Settings</Text>*/}
            {/*</Box>*/}

            <Box overflowX="auto" boxShadow="md" borderRadius="md" bg="white" p={4}>
                <Table variant="simple" size="sm">
                    <Thead>
                        <Tr>
                            <Th>ID</Th>
                            <Th>Field Name</Th>
                            <Th>Field Value</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {metaData.map((meta) => (
                            <Tr key={meta.id}>
                                <Td>{meta.id}</Td>
                                <Td>{meta.labelName}</Td>
                                <Td>
                                    <Input
                                        size="sm"
                                        value={meta.fieldValue}
                                        disabled={meta.fieldName==="CLIENT_NAME"}
                                        onChange={(e) => handleInputChange(meta.id, "field_value", e.target.value)}
                                    />
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>

                <Flex justify="flex-end" mt={4}>
                    <Button colorScheme="blue" size="sm" onClick={handleSave}>
                        सेभ गर्नुहोस्
                    </Button>
                </Flex>
            </Box>
        </Flex>
    );
}

export default Setting;